module.exports = __webpack_public_path__ + "media/images/flags/ca-d72057feba4dd447b46932c302d90117.svg";